// extracted by mini-css-extract-plugin
export default {"errorMessage":"error-message_errorMessage","errorMessageAlt":"error-message_errorMessageAlt"};